import { CommandData } from './command.data';
import { LayerData } from './layer/layer.data';
import { LabelData } from './label/label.data';

export class HistoryData {
  
  static states:Array<any>;
  static appliccatin: Array<any>;
  static _commands: Array<CommandData> = [];

  /**
	 * Constructor
	 */
  constructor() {

  }

  /**
   * 
   */		
  static add(label: LabelData, target: LayerData, command: string, data: any = null): void {
    this._commands.push(new CommandData(label, target, command, data));
  }

  /**
		 * Delete label 
		 */
  static deleteLabel(label: LabelData): void {
    for (var i: number = 0; i < this._commands.length; i++) {
      if (this._commands[i].label == label) {
        this._commands[i].cleanup();
        this._commands.splice(i, 1);
        i--;
      }
    }
  }

  /**
   * Delete label 
   */
  static deleteLayer(layer: LayerData): void {
    for (var i: number = 0; i < this._commands.length; i++) {
      if (this._commands[i].target == layer) {
        this._commands.splice(i, 1);
        i--;
      }
    }
  }

  /**
		 * Undo
		 */
  static undo(): any {
    if (this._commands.length > 0) {
      var command: CommandData = this._commands.pop();
      if (command.action == CommandData.ADD_LAYER) {
        for (var i: number = 0; i < this._commands.length; i++) {
          if (this._commands[i].target == command.backup) {
            this._commands[i].target = command.target;
          }
        }
      }
      command.apply();
      let label:LabelData = command.label;
      let layer: LayerData = command.target;
      command.cleanup();
      return {label: label, layer: layer};
    }
    return null;
  }

  /**
		 * Cleanup 
		 */
  static cleanup(): void {
    for (var i: number = 0; i < this._commands.length; i++) {
      this._commands[i].cleanup();
    }
    this._commands = [];
  }

  static get historyLength(): number {
    return this._commands.length;
  }

}